import { ValidationRequest } from '../../../types'

export const formatValidationRequestFailedMessage = ({
  hasNoEligibleOrganisationType,
  validationRequest,
  t
}: {
  hasNoEligibleOrganisationType: boolean
  validationRequest?: ValidationRequest
  t: (descriptor: string) => string
}) => {
  if (!validationRequest?.rejectedAt) {
    return null
  }

  if (hasNoEligibleOrganisationType) {
    return t('typography.organisationTypeIsIneligible')
  }

  if (validationRequest?.rejectionReasonCode) {
    return t(`validationRequest.rejectionReasons.${validationRequest?.rejectionReasonCode}`)
  }

  return t('typography.organisationIsNotValidCause')
}
